import {Button} from 'antd'
import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {canPreviewWf, previewWf} from './previewWf.mjs'

export default function PropertiesPaneButtonPreview(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const [node] = map.useSelectedNodes()

    if (! canPreviewWf(map, node)) {
        return null
    }

    const handleClick = e => {
        const target = e.altKey ? '_self' : '_blank'
        previewWf(map, node, target)
    }

    return filterByLicense('M00030001',
        <Button
            onClick={handleClick}
            {...props}
        >
            流程看板
        </Button>
    )
}
